module.exports = __webpack_public_path__ + "static/media/total_devices.bef38abd.svg";